// Full-document render of the pillows HomePage: PageSkeleton (the React
// document shell) wrapping the hero-options, hero-sidekick, and body islands
// in the same order as the legacy tempur.html layout block.
import React from "react";

import { templates } from "@reactivated";

import { HomePageBody } from "../components/HomePageBody";
import { HomePageHeroOptions } from "../components/HomePageHeroOptions";
import { HomePageHeroSidekick } from "../components/HomePageHeroSidekick";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
export const Template = (
    props: templates.HomePageTemplate,
): React.JSX.Element => {
    const { page } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <HomePageHeroOptions page={page} />
            <HomePageHeroSidekick page={page} />
            <HomePageBody page={page} />
        </PageSkeleton>
    );
};
